import { styled } from '@mui/material/styles';
import { Panel } from 'src/UIKit';

export type TintedPanelTone = 'error' | 'warning' | 'info' | 'success';

/** Outlined panel filled with the pale `lighter` shade of a semantic color. */
export const TintedPanel = styled(Panel, {
  shouldForwardProp: prop => prop !== 'tone',
})<{ tone: TintedPanelTone }>(({ theme, tone }) => ({
  backgroundColor: theme.palette[tone].lighter,
}));
